__turbopack_context__.v({
  "allIcon": "SignalsView-module__ZXXfYq__allIcon",
  "card": "SignalsView-module__ZXXfYq__card",
  "cardBody": "SignalsView-module__ZXXfYq__cardBody",
  "cardFooter": "SignalsView-module__ZXXfYq__cardFooter",
  "cardHeader": "SignalsView-module__ZXXfYq__cardHeader",
  "cardMeta": "SignalsView-module__ZXXfYq__cardMeta",
  "cardTitle": "SignalsView-module__ZXXfYq__cardTitle",
  "cite": "SignalsView-module__ZXXfYq__cite",
  "compare": "SignalsView-module__ZXXfYq__compare",
  "count": "SignalsView-module__ZXXfYq__count",
  "detail": "SignalsView-module__ZXXfYq__detail",
  "detailHeader": "SignalsView-module__ZXXfYq__detailHeader",
  "detailTitle": "SignalsView-module__ZXXfYq__detailTitle",
  "dossier": "SignalsView-module__ZXXfYq__dossier",
  "dossierHeader": "SignalsView-module__ZXXfYq__dossierHeader",
  "dossierSection": "SignalsView-module__ZXXfYq__dossierSection",
  "factChips": "SignalsView-module__ZXXfYq__factChips",
  "factGroup": "SignalsView-module__ZXXfYq__factGroup",
  "factList": "SignalsView-module__ZXXfYq__factList",
  "factWeb": "SignalsView-module__ZXXfYq__factWeb",
  "failed": "SignalsView-module__ZXXfYq__failed",
  "footerSpacer": "SignalsView-module__ZXXfYq__footerSpacer",
  "layout": "SignalsView-module__ZXXfYq__layout",
  "muted": "SignalsView-module__ZXXfYq__muted",
  "nextStep": "SignalsView-module__ZXXfYq__nextStep",
  "points": "SignalsView-module__ZXXfYq__points",
  "profileLink": "SignalsView-module__ZXXfYq__profileLink",
  "quotes": "SignalsView-module__ZXXfYq__quotes",
  "rail": "SignalsView-module__ZXXfYq__rail",
  "railHeading": "SignalsView-module__ZXXfYq__railHeading",
  "reason": "SignalsView-module__ZXXfYq__reason",
  "researching": "SignalsView-module__ZXXfYq__researching",
  "row": "SignalsView-module__ZXXfYq__row",
  "rowName": "SignalsView-module__ZXXfYq__rowName",
  "rowText": "SignalsView-module__ZXXfYq__rowText",
  "rows": "SignalsView-module__ZXXfYq__rows",
  "sectionHeading": "SignalsView-module__ZXXfYq__sectionHeading",
  "sourceIndex": "SignalsView-module__ZXXfYq__sourceIndex",
  "sourceLink": "SignalsView-module__ZXXfYq__sourceLink",
  "sources": "SignalsView-module__ZXXfYq__sources",
  "spin": "SignalsView-module__ZXXfYq__spin",
  "srOnly": "SignalsView-module__ZXXfYq__srOnly",
  "stack": "SignalsView-module__ZXXfYq__stack",
  "status": "SignalsView-module__ZXXfYq__status",
  "subject": "SignalsView-module__ZXXfYq__subject",
  "summary": "SignalsView-module__ZXXfYq__summary",
  "typeFilters": "SignalsView-module__ZXXfYq__typeFilters",
  "why": "SignalsView-module__ZXXfYq__why",
});
